module.exports = __webpack_public_path__ + "stylesheets/footer_f7da464ae85f74656efaff6efdb52673.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/footer.less
// module id = fAML
// module chunks = 151